import { Status } from "./RequestStatus";
// import { type } from "os";

// ProgressCallback is a function provided to receive progress notifications (e.g. for a download)
export interface ProgressCallback {
    (percentage: number): void; // percent completion as a number between 0 an 100
}

// serializable representation of a job
export type Job = string[] // [methodName, ...args]

export function isJob(j: any): j is Job {
    return j && j.length && typeof j[0] === "string"
}

export const jobPrefix = (job: Job) => job.slice(0, -1);

export function jobsEqual(a: Job, b: Job): boolean {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
}

// executable representaiton of a job
export type JobX = () => Promise<Status>;

// turns a Job into a JobX
export type JobXer = (job: Job) => JobX;


// Stores may have long running jobs they need to interleave with UI tasks
// or hand off to a web worker. This is a strict FIFO queue.
export interface Queueable {
    // add a job to the queue, true if added, should fail to add dups
    enqueue(job: Job): boolean;
    // look at the top entry of the queue--really only needed for testing
    peek(): Job | undefined;
    // pause the queue
    pause(): boolean;
    // start the queue
    start(): boolean;
    // run one job, true if a job was found
    step(): Promise<Status>
    // count of pending downloads
    pending(): Promise<number>;
}

export interface AdvancedQueuable {
}
